/**
 * @file src/_modulos/prenota/tabela/layouts/tabela/columns/components/prioridade.tsx
 * @description Componentes e funções relacionadas à prioridade das pré-notas
 */

"use client";

import {
  IconSquareChevronsDownFilled,
  IconSquareChevronsUpFilled,
  IconSquareMinusFilled,
} from "@tabler/icons-react";
import {
  BadgePreset,
  CategoryConfig,
  createIconOnlyPreset,
  createEmptyPreset,
  createInvalidPreset,
} from "./utils";

/**
 * Configuração das categorias de prioridade
 */
const PRIORITY_CATEGORIES: Record<string, CategoryConfig> = {
  alta: {
    color: "text-rose-600 dark:text-rose-400",
    icon: IconSquareChevronsUpFilled,
    getTooltip: () => "Prioridade Alta – atenção imediata.",
  },
  media: {
    color: "text-lime-600 dark:text-lime-400",
    icon: IconSquareMinusFilled,
    getTooltip: () => "Prioridade Média – atenção necessária.",
  },
  baixa: {
    color: "text-teal-600 dark:text-teal-400",
    icon: IconSquareChevronsDownFilled,
    getTooltip: () => "Prioridade Baixa – sem urgência.",
  },
} as const;

/**
 * Valores válidos para prioridade
 */
const VALID_PRIORITIES = ["Alta", "Média", "Baixa"];

/**
 * Obtém preset de prioridade
 */
export function getPriorityPreset(p?: string | null): BadgePreset {
  const key = p?.trim() ?? "";

  if (!key) {
    return createEmptyPreset(
      <span>Sem Prior.</span>,
      "Prioridade não definida."
    );
  }

  // Normalizar entrada
  const normalizedKey = key.toLowerCase();
  let categoryKey: string;

  if (normalizedKey === "alta") {
    categoryKey = "alta";
  } else if (normalizedKey === "media" || normalizedKey === "média") {
    categoryKey = "media";
  } else if (normalizedKey === "baixa") {
    categoryKey = "baixa";
  } else {
    return createInvalidPreset(key, VALID_PRIORITIES, "Inválida");
  }

  const config = PRIORITY_CATEGORIES[categoryKey];
  return createIconOnlyPreset(config, config.color);
}
